import { render, staticRenderFns } from "./whiteSectionPortfolio.vue?vue&type=template&id=274ac818&"
import script from "./whiteSectionPortfolio.vue?vue&type=script&lang=js&"
export * from "./whiteSectionPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "whiteSectionPortfolio.vue"
export default component.exports